import { SyntheticEvent } from 'react';

export const StopPropagation = (event: SyntheticEvent) => event?.stopPropagation();
